<template>
  <div class="container-fluid">
    <div
      class="home page-content__header-description"
      style="display: flex; margin-bottom: 20px;"
    >
      <h2 style="flex: 1;">Exclusions</h2>
      <div
        v-if="usertype != 'customer admin'"
        style="display: flex; margin-right: 20px;"
      >
        <span style="flex: 1; align-items: center; margin-right: 10px;">
          <button class="btn btn-xl btn-primary create_button" @click="show">
            + Add
          </button>
        </span>
      </div>
    </div>

    <div style="width: 100%">
      <h3 v-if="!getLoadingState" class="pagin_style">
        Showing
        {{
          paginationInfo.total > 0
            ? `${paginationInfo.first} - ${paginationInfo.last}
          ${paginationInfo.ofText} ${paginationInfo.total} ${
                paginationInfo.total > 1 ? "Devices" : "Device"
              }`
            : "no device"
        }}
      </h3>
      <el-input
        style="width: 30%"
        class="el-input el-input--prefix"
        placeholder="Search"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <div class="main-container" v-if="!getLoadingState">
        <vue-good-table
          :columns="fields"
          :rows="lists"
          :pagination-options="{ enabled: true }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'owner'">
              {{
                props.row.owner.length > 0 &&
                props.row.owner[0] !== null &&
                props.row.owner[0].name
                  ? props.row.owner[0].name
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'DeviceID'">
              {{ props.row.DeviceID ? props.row.DeviceID : "----" }}
            </span>

            <span v-if="props.column.field == 'payload'">
              {{
                props.row.payload.BatteryData.SOC
                  ? props.row.payload.BatteryData.SOC
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'timestamp'">
              {{
                props.row.payload.Timestamp
                  ? props.row.payload.Timestamp
                  : "----"
              }}
            </span>

            <span v-if="props.column.field == 'totalPaid'">
              {{
                (props.row.totalAmountPaid
                  ? props.row.totalAmountPaid
                  : "----"
                ).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </span>

            <span v-if="props.column.field == 'actions'">
              <div class="action_style">
                <a-dropdown :trigger="['click']">
                  <p class="ant-dropdown-link ellipsis_style">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </p>
                  <template slot="overlay">
                    <a-menu>
                      <a-menu-item class="action_delete" key="1">
                        <p @click="removeFromExclusionList(props.row.DeviceID)">
                          <i class="fa fa-trash"> Delete</i>
                        </p>
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :currentPage="pagination.currentPage"
              :total="pagination.totalRecords"
              :pageChanged="pageChanged"
              :perPageChanged="props.perPageChanged"
              :perPage="pagination.limit"
              @paginated-info="paginationInfo = $event"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>

      <modal
        @close="hide"
        width="500px"
        height="auto"
        name="my-first-modal"
        style="border-radius: 28px !important"
        class="first-modal"
      >
        <div class="form">
          <form name="myForm">
            <h4>
              Input Device IDs
            </h4>
            <input
              type="text"
              class="form-control form-control"
              :required="true"
              v-model="deviceIds"
              placeholder="Enter Device Ids e.g, 411183,91333"
            />

            <div class="row">
              <button type="button" class="button-cancel" @click="hide">
                Cancel
              </button>
              <button
                type="submit"
                class="button-add"
                :disabled="getLoadingState"
                @click.prevent="addToExclusionList"
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
    <div
      style="height: 300px; background-color: white; display: flex; align-items: center; justify-content: center"
      v-if="getLoadingState"
    >
      Loading, please wait...
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import BillingUpdate from "../users/BillingUpdate.vue";
import {
  Offcanvas,
  OffcanvasClose,
  OffcanvasContent
} from "vuikit/lib/offcanvas";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import Noty from "noty";
import { debounce } from "../../../utils/util";

export default {
  name: "exclusion",
  components: {
    "vk-offcanvas-content": OffcanvasContent,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "billing-update": BillingUpdate
  },
  computed: {
    ...mapGetters(["getGlobalTableOptions"]),
    getLoadingState: {
      get() {
        return this.loading;
      }
    },
    pagination: {
      get() {
        return this.devicePayload;
      }
    },
    tableOptions: {
      get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    getSortOrder: {
      get() {
        return {
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    },
    getParams: {
      get() {
        return {
          page: this.tableOptions.currentPage,
          limit: this.tableOptions.currentPerPage,
          search: this.searchTerm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    }
  },
  data() {
    return {
      paginationInfo: {},
      lists: [],
      showModal: true,
      showSetup: false,
      loading: false,
      deviceIds: "",
      sortField: "",
      searchTerm: "",
      sortOrder: "",
      totalPages: 1,
      devicePayload: {
        currentPage: 1,
        totalRecords: 1,
        totalPages: 1,
        limit: 20
      },
      totalRecords: 1,
      fields: [
        {
          field: "DeviceID",
          label: "Device ID",
          sortable: true
        },
        {
          field: "owner",
          label: "Owner",
          sortable: true
        },
        {
          field: "payload",
          label: "Battery SOC",
          sortable: true
        },
        {
          field: "timestamp",
          label: "Last Seen",
          sortable: true
        },
        {
          field: "actions",
          label: "",
          sortable: false
        }
      ]
    };
  },
  methods: {
    pageChanged(e) {
      if (this.devicePayload.currentPage !== e.currentPage) {
        this.devicePayload.currentPage = e.currentPage;
        this.getExcursionList();
      }
    },
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    showToast(text, type = "success") {
      new Noty({
        theme: "bootstrap-v3",
        text: text,
        type,
        timeout: 1000
      }).show();
    },
    selectedField(field) {
      switch (field) {
        case "version":
          return "Version";
        case "owner":
          return "ownerName";
        case "payload":
          return "BatteryCapacity";
        default:
          return field;
      }
    },
    getExcursionList(params = undefined) {
      let path = "";
      if (params) {
        Object.entries(params).map(x => {
          path = path + `&${x[0]}=${x[1]}`;
        });
      }
      this.loading = true;
      const HTTP = this.$httpUtils.FastAPIHTTP;
      HTTP.get(
        `/devices/exclusion-list?page=${this.devicePayload.currentPage}&limit=${this.devicePayload.limit}${path}`
      ).then(res => {
        this.loading = false;
        this.lists = res.data.data.data.devices;
        this.devicePayload = {
          ...this.devicePayload,
          totalPages: res.data.data.data.totalPages,
          totalRecords: res.data.data.data.totalRecords
        };
      });
    },
    addToExclusionList() {
      this.loading = true;

      const HTTP = this.$httpUtils.FastAPIHTTP;
      HTTP.post("/devices/add-to-exclusion", { deviceId: this.deviceIds })
        .then(res => {
          this.loading = false;
          this.showToast(res.data.message);
          this.hide();
          this.getExcursionList();
        })
        .catch(e => {
          this.loading = false;
          this.showToast(e.response.data.detail, "error");
        });
    },
    removeFromExclusionList(deviceId) {
      this.loading = true;

      const HTTP = this.$httpUtils.FastAPIHTTP;
      HTTP.delete(`/devices/exclusion-list/${deviceId}`)
        .then(res => {
          this.showToast(res.data.message);
          this.hide();
          this.loading = false;
          this.getExcursionList();
        })
        .catch(e => {
          this.showToast(e.response.data.detail, "error");
          this.loading = false;
        });
    },
    onSortChange(params) {
      this.sortField = params[0].field;
      this.sortOrder = params[0].type;
      return params;
    }
  },
  watch: {
    paginatedInfo: async function(n, o) {
      if (n.first !== o.first) {
        await this.getExcursionList({ ...this.getParams });
      }
    },
    getSortOrder: async function(n, o) {
      if (n.sortField !== o.sortField || n.sortOrder !== o.sortOrder) {
        await this.getExcursionList({
          ...this.getParams,
          sortField: this.selectedField(n.sortField),
          sortOrder: n.sortOrder
        });
      }
    },
    tableOptions: async function(n, o) {
      if (
        n.currentPage !== o.currentPage ||
        n.currentPerPage !== o.currentPerPage
      ) {
        await this.getExcursionList({ ...this.getParams });
      }
    },
    searchTerm: debounce(async function(n, o) {
      if (n !== o) {
        await this.getExcursionList({ ...this.getParams });
      }
    }, 600)
  },
  mounted() {
    if (this.devicePayload.currentPage == 1) {
      this.getExcursionList();
    }
  }
};
</script>

<style scoped>
.home {
  padding: 20px;
  padding-bottom: 0;
  padding-left: 0;
  margin-bottom: 0;
  margin-left: 0;
}

.main-container {
  height: calc(100vh - 330px);
  margin-bottom: 8rem;
}

.form {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  margin-top: 20px;
}

.row {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}

.button-add {
  padding: 5px;
  color: white;
  border-color: green;
  background: green;
  border-radius: 4px;
  width: 40%;
  margin-left: 3px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 40%;
  border-radius: 4px;
}

.button-cancel:hover {
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
}

.el-input {
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/exclusionList/index.vue